import React from 'react'
import './UsageStep.scoped.sass'

import { Button } from '@/components/Button/Button'
import { ReactComponent as ComeBackArrow } from '@/assets/icons/come-back-arrow.svg'
import SampleScreenshotSrc from '@/assets/screenshots/labels-explanation.png'
import modalService from '@/services/modal.service'
import threadsService from '@/app-domains/threads/threads.service'
import store from '@/core/store'

const CreateLabelExplanationStep = (props) => {
  const {
    // usage,
    goToPreviousStep,
  } = props

  function continueOnboarding () {
    threadsService.queryLastThreads().then(() => store.commit('THREADS:UPDATED'))
    modalService.close()
  }

  return (
    <div className='main-container'>
      <div className='welcome-header'>
        <div className='come-back-arrow' onClick={goToPreviousStep}>
          <ComeBackArrow />
        </div>
        <span>Managing Labels</span>
      </div>
      <div className='info'>
        <p>Creating a label is really easy:</p>
      </div>
      <div className='info'><img src={SampleScreenshotSrc}/> </div>
      <div className='info'>
        <p>See that highlighted button in the screenshot? That's the label creation one, clicking on it will prompt the creation modal</p>
      </div>
      <div className='info'>
        <p>Once the modal appears, just fill in the label name field and click "Save", after that, your new label will appear in the "Labels" section</p>
      </div>
      <div className='buttons'>
        <div className='quick-setup-button'>
          <Button content='Close' click={continueOnboarding} className='quick-setup-button' size='regular'/>
        </div>
      </div>
    </div>
  )
}

export default CreateLabelExplanationStep
